import type { RouteRecordRaw, Router } from 'vue-router'

const SupportContractRoutes: RouteRecordRaw = {
  path: '/contract/nonFinancial/support',
  name: 'SupportModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'SupportMainRoute',
      component: () => import('./views/SupportView.vue'),
      meta: {
        title: 'support.supportContract',
      },
    },
    {
      path: 'create',
      name: 'SupportCreateRoute',
      component: () => import('./views/SupportUpsertView.vue'),
      meta: {
        title: 'support.createSupportContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:supportId',
      name: 'SupportEditRoute',
      component: () => import('./views/SupportUpsertView.vue'),
      meta: {
        title: 'support.editSupportContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:supportId',
      name: 'ViewSupportRoute',
      component: () => import('./views/SingleSupportView.vue'),
      meta: {
        title: 'support.ViewSupport',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(SupportContractRoutes)
}
